/*
 * @Author: Gang Jiang 
 * @Date: 2025-02-19 21:48:47 
 * @Last Modified by: Gang Jiang
 * @Last Modified time: 2025-02-27 16:15:14
 */
<template>
  <div class="help-page">
    <breadcrumbs url="about-artemis-ads" />
    <div class="docs">
      <h1>{{ st('helpDocs.amazonAttributionReporting.h1') }}</h1>
      <h2>
        {{ st('helpDocs.amazonAttributionReporting.h2Halo') }}
      </h2>
      <p>{{ st('helpDocs.amazonAttributionReporting.pHalo1') }}</p>
      <p>{{ st('helpDocs.amazonAttributionReporting.pHalo2') }}</p>
      <h2>{{ st('helpDocs.amazonAttributionReporting.h2Total') }}</h2>
      <p>{{ st('helpDocs.amazonAttributionReporting.pTotalIntro') }}</p>
      <ul>
        <li>{{ st('helpDocs.amazonAttributionReporting.liDisc1') }}</li>
        <li>{{ st('helpDocs.amazonAttributionReporting.liDisc2') }}</li>
        <li>{{ st('helpDocs.amazonAttributionReporting.liDisc3') }}</li>
        <li>{{ st('helpDocs.amazonAttributionReporting.liDisc4') }}</li>
      </ul>
      <p>{{ st('helpDocs.amazonAttributionReporting.pTotalAfter') }}</p>
      <h2>
        {{ st('helpDocs.amazonAttributionReporting.h2Exceptions') }}
      </h2>
      <p>{{ st('helpDocs.amazonAttributionReporting.pExcIntro') }}</p>
      <ul>
        <li>{{ st('helpDocs.amazonAttributionReporting.liExc1') }}</li>
        <li>{{ st('helpDocs.amazonAttributionReporting.liExc2') }}</li>
        <li>{{ st('helpDocs.amazonAttributionReporting.liExc3') }}</li>
        <li>{{ st('helpDocs.amazonAttributionReporting.liExc4') }}</li>
      </ul>

      <p>{{ st('helpDocs.amazonAttributionReporting.pComm1') }}</p>
      <p>{{ st('helpDocs.amazonAttributionReporting.pComm2') }}</p>

      <h2>
        {{ st('helpDocs.amazonAttributionReporting.h2Deduct') }}
      </h2>
      <p>{{ st('helpDocs.amazonAttributionReporting.pDedYes') }}</p>
      <p>{{ st('helpDocs.amazonAttributionReporting.pDed1') }}</p>
      <p>{{ st('helpDocs.amazonAttributionReporting.pDed2') }}</p>
      <p>{{ st('helpDocs.amazonAttributionReporting.pDed3') }}</p>
    </div>
  </div>
</template>
<script setup>
import Breadcrumbs from '../breadcrumbs.vue'
import { useSellerI18n } from '@/composables/useSellerI18n'

const { st } = useSellerI18n()
</script>
